import SettingsModule, {SettingsMenuTopCategory} from "../../../../core/modules/settings-module";
import {SettingsParentSection} from "../../const";

export default class SettingsModuleDataStorage extends SettingsModule {

    constructor() {
        super({
            name                     : "Data Storage",
            description              : "",
            svgIcon                  : "isvg-data-storage",
            typeLabel                : "Organization account",
            settingsUrl              : "settings/data-storage",
            settingsMenuTopCategory  : SettingsMenuTopCategory.ORGANIZATION
        });

        this.parentSection          = SettingsParentSection.SYSTEM

        this.canDisable             = false
        this.hasStatus              = false
    }

}
